import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Product } from '../products/product';
import { ProductsService } from '../products/products.service';
import { ConfigService } from '../config/config.service';
import { LoggingService } from '../loging/logging.service';
export class ProductAdminComponent implements OnInit {

    products: Product[];
    selectedProduct: Product;
    config: any;
/**
 * @param {?} productService
 * @param {?} router
 * @param {?} configService
 * @param {?} loggingService
 */
constructor(
private productService: ProductsService,
private router: Router,
private configService: ConfigService,
private loggingService: LoggingService
    ) {
  }
/**
 * @return {?}
 */
ngOnInit(): void {
      this.loggingService.log('ProductAdminComponent:ngOnInit()');
      this.configService.getConfig(
          (config:any) => {
              this.config = config;
              this.getProducts();
          });
    }
/**
 * @return {?}
 */
getProducts(): void {
      //window.alert('products.components.ts: getProducts(): Begin');
      this.productService.getProducts().subscribe(
          products => {
              this.products = products;
          });
  }
/**
 * @param {?} product
 * @return {?}
 */
onSelect(product: Product): void {
      this.selectedProduct = product;
  }
/**
 * @param {?} product
 * @return {?}
 */
deleteProduct(product: Product): void {
      this.productService.deleteProduct(product.id).subscribe(
          () => {
              this.products = this.products.filter(p => p !== product);
              if (this.selectedProduct === product) {
                  this.selectedProduct = null;
              }
          });
  }
/**
 * @return {?}
 */
addProduct(): void {
      this.router.navigate(['/product-admin-details', 'NewProduct']);
  }
/**
 * @param {?} id
 * @return {?}
 */
gotoDetail(id: string): void {
      this.router.navigate(['/product-admin-details', id]);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'my-product-admin',
  template: "<p> These are the latest products going viral. </p> <ul class=\"products\"> <li *ngFor=\"let product of products\"> <span (click)=\"gotoDetail(product.id)\">{{product.name}}</span> <span class=\"glyphicon glyphicon-trash\" (click)=\"deleteProduct(product);$event.stopPropagation()\"></span> </li> </ul> <button class=\"add\" (click)=\"addProduct();$event.stopPropagation()\">Add Product</button>",
  styles: [".selected { background-color: #CFD8DC !important; color: white; } .products { margin: 0 0 2em 0; list-style-type: none; padding: 0; text-align: left; } .products li { cursor: pointer; left: 0; background-color: #EEE; margin: .5em; padding: .3em 0; height: 2em; border-radius: 4px; } .products li.selected:hover { background-color: #BBD8DC !important; color: white; } .products li:hover { color: #607D8B; background-color: #DDD; left: .1em; } button.remove { float: right; font-size: small; margin-top: .2em; height: 1.6em; margin-right: .8em; background-color: gray !important; color: white; } button.delete { float: right; margin-top: 2px; margin-right: .8em; background-color: gray !important; color: white; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ProductsService, },
{type: Router, },
{type: ConfigService, },
{type: LoggingService, },
];
}

function ProductAdminComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProductAdminComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductAdminComponent.ctorParameters;
/** @type {?} */
ProductAdminComponent.prototype.products;
/** @type {?} */
ProductAdminComponent.prototype.selectedProduct;
/** @type {?} */
ProductAdminComponent.prototype.config;
/** @type {?} */
ProductAdminComponent.prototype.productService;
/** @type {?} */
ProductAdminComponent.prototype.router;
/** @type {?} */
ProductAdminComponent.prototype.configService;
/** @type {?} */
ProductAdminComponent.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
